import * as React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'common/appState';
import { redirectToUrl } from 'common/actions/navigationAction';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import {
    saveFilters,
    autocompleteRequest,
    clearFilters,
    paginationRequest,
} from 'features/pagination/actions/paginationActions';
import { isTenant } from 'features/user/selectors/userSelectors';

import { CheckEvidences as CheckEvidencesComponent } from '../components/CheckEvidences';
import { CheckActiveBenefit } from '../models/checkModel';
import { getCheckActiveBenefits } from '../selectors/checkSelectors';

export interface CheckEvidencesStateProps {
    checkActiveBenefits: CheckActiveBenefit[];
    filter?: PaginationFilters;
    isTenant: boolean;
}

interface CheckEvidencesContainerDispatchProps {
    autocompleteRequest: typeof autocompleteRequest;
    redirectToUrl: typeof redirectToUrl;
    clearFilters: typeof clearFilters;
    saveFilters: typeof saveFilters;
    paginationRequest: typeof paginationRequest;
}

export type CheckEvidencesProps = CheckEvidencesStateProps & CheckEvidencesContainerDispatchProps;

class CheckEvidences extends React.Component<CheckEvidencesProps> {
    public render(): JSX.Element {
        return <CheckEvidencesComponent {...this.props} />;
    }
}

const mapStateToProps = (state: AppState): CheckEvidencesStateProps => ({
    checkActiveBenefits: getCheckActiveBenefits(state),
    filter: getFilterParams(state, PaginationView.CheckEvidence),
    isTenant: isTenant(state),
});

export const CheckEvidencesContainer = connect(mapStateToProps, {
    redirectToUrl,
    autocompleteRequest,
    clearFilters,
    saveFilters,
    paginationRequest,
})(CheckEvidences);
